import AddIcon from "@mui/icons-material/Add";

import EditIcon from "@mui/icons-material/Edit";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link as LinkRRD } from "react-router-dom";

import {
  Breadcrumbs,
  Button,
  Card,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { border, Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useForm } from "react-hook-form";
import { useCSVReader } from "react-papaparse";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
import { Bolt } from "@mui/icons-material";
import Body from "../../layout/Body";
// import AddPartner from "./AddPartner";
import { getAllPartnerAction } from "../../redux/toolkit/partner/allPartner";
import { useDispatch, useSelector } from "react-redux";
import { useStyles } from "../../theme/theme";
// import EditPartner from "./EditPartner";
// import LivePartner from "./LivePartner";
import Chip from "@mui/material/Chip";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { dateFormatStartFun } from "../../helper/dateConverter";
import { getAllPartnerRevenueAction } from "../../redux/toolkit/partner/allPartnerRevenue";
import AddVideo from "./AddVideo";
import { get, set } from "lodash";
import { getAllVideoAction } from "../../redux/toolkit/video/allVideo";
import { render } from "@testing-library/react";
import EditVideo from "./EditVideo";
import { getVideoStatAction } from "../../redux/toolkit/video/videoStat";
import { getAllPartnerActionNoLimit } from "../../redux/toolkit/partner/getAllPartnerNoLimit";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/all-video"
      >
        All Video
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Video Stat
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h4">
      All Video
    </Typography>
  </Stack>
);

const VideoStat = () => {
  const dispatch = useDispatch();
  const [video, setAddVideo] = useState(false);
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  const [editVideoShow, SetEditVideoShow] = useState(false);
  const [videoId, setVideoId] = useState("");
  const [snack, setSnack] = useState(false);
  const classes = useStyles();

  const videoStatData = useSelector((state) => state.videoStat);
  const { loading, data, total, status, message } = videoStatData;

  const partnerDetails = useSelector((state) => state.allPartnerWithoutLimit);

  const videoColumn = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      minWidth: 80,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },

    {
      field: "userId",
      headerName: "userId",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.userId?._id || "---"}</Typography>;
      },
    },

    {
      field: "Email",
      headerName: "Email",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.userId?.email || "---"}</Typography>;
      },
    },

    {
      field: "video_id",
      headerName: "video_id",
      flex: 1,
      minWidth: 400,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.video_id?._id || "---"}</Typography>;
      },
    },

    {
      field: "triggerpoints",
      headerName: "triggerpoints",
      flex: 1,
      minWidth: 400,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>
            {triggerPoints[params?.row?.video_id?.triggerpoints] || "---"}
          </Typography>
        );
      },
    },

    {
      field: "Partner",
      headerName: "Partner",
      flex: 1,
      minWidth: 400,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>{params?.row?.video_id?.partnerId ? getPartnerName(params?.row?.video_id?.partnerId) : "---"}</Typography>
        );
      },
    },

    {
      field: "shown_at",
      headerName: "shown_at",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return moment(params?.row?.shown_at)
          .local()
          .format("DD-MM-YYYY hh:mm:ss A");
        // moment(params?.row?.created_at).local().format("DD-MM-YYYY,h:mm:ss a")
      },
    },

    {
      field: "saw_full_video",
      headerName: "saw_full_video",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>
            {params?.row?.saw_full_video ? "true" : "false"}
          </Typography>
        );
      },
    },

    {
      field: "skips_video",
      headerName: "skips_video",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>{params?.row?.skips_video ? "true" : "false"}</Typography>
        );
      },
    },

    {
      field: "continue_fre_count",
      headerName: "continue_fre_count",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.continue_fre_count}</Typography>;
      },
    },
  ];

  let triggerPoints = {
    1: "profiler start",
    2: "profiler complete",
    3: "survey complete",
    4: "survey disqualification",
    5: "Parner Open",
  };

   let getPartnerName = (partnerId) => {
    if (!partnerId) return "";
    let partnerName = partnerDetails?.data?.find((data) => data?._id.toString() === partnerId);
    return partnerName?.name;
  };

  useEffect(() => {
    dispatch(getAllPartnerActionNoLimit({}));
  }, []);

  useEffect(() => {
    setSnack(true);
    dispatch(
      getVideoStatAction({
        page: pageState.page,
        pageSize: pageState.pageSize,
      })
    );
  }, [pageState.page, pageState.pageSize]);

  return (
    <>
      <Helmet>
        <title> Real Opinion Admin | All Video</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      <Body>
        {/* <Stack
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignContent: "center",
          }}
        >
          <Stack direction="row" spacing={0} sx={{ ml: 2 }}>
            <Button
              variant="contained"
              color="btn"
              startIcon={<AddIcon />}
              onClick={() => {
                setAddVideo(true);
              }}
            >
              Create video
            </Button>
          </Stack>
        </Stack> */}

        <Card sx={{ my: 2 }}>
          <Stack direction={"row"} alignItems="center" sx={{ ml: 1 }}>
            <Typography sx={{ my: 1 }} variant="h6">
              Admin / All Video Stat
            </Typography>
          </Stack>

          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              rows={data}
              autoHeight
              columns={videoColumn}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              rowsPerPageOptions={[25, 50, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
              }}
              rowCount={total}
              paginationModel={setPageState}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>

        {video && <AddVideo state={video} setState={setAddVideo} />}

        <SnackBarUI
          state={snack}
          setState={setSnack}
          status={status}
          message={message}
        />
      </Body>
    </>
  );
};

export default VideoStat;
